import React from 'react'

function CurrentMatchState() {
  return (
    <div>CurrentMatchState</div>
  )
}

export default CurrentMatchState